import Vue from "vue";
import App from "./App.vue";
import router from "@/routers";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/vue-i18n";
import Vuelidate from "vuelidate";
import VueGtag from "vue-gtag";
import settings from "@/settings";
import VueSocialSharing from "vue-social-sharing";
import VueCompositionAPI from "@vue/composition-api";
import VueQRCodeComponent from "./components/VueQRCodeComponent.vue";
import VueMeta from 'vue-meta'

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(VueCompositionAPI);
Vue.use(VueSocialSharing);
Vue.use(VueMeta);

var gaConnectedSiteTags = settings.gaConnectedSiteTags.split(",");
var vueGtagConnectedSiteTags = [];
for (var i = 0; i < gaConnectedSiteTags.length; i++) {
  vueGtagConnectedSiteTags.push({ id: gaConnectedSiteTags[i] });
}

Vue.use(
  VueGtag,
  {
    includes: vueGtagConnectedSiteTags,
    config: {
      id: settings.gaMeasurementId,
      params: {
        send_page_view: false,
      },
    },
  },
  router
);

// Register the Vue component
Vue.component("qr-code", VueQRCodeComponent)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
